import React from 'react';
import { useTheme } from '@mui/material/styles';
import { useMediaQuery } from '@mui/material';
import LogInlineLink from '#component/general/log-inline-link';
import { deviceSettingsEventType, shipmentEventType, warehouseEventType, projectEventType } from '#type';
import { getDeviceUrl } from '#helper';

const EventDescription = ({ log, isEventTab }) => {
  const { device, event: { id }, timestamp, shipment, appliance, applianceGroup, project } = log;
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const wasEdited = isEventTab ? '' : ' was ';
  const deviceUrl = getDeviceUrl(device?.id, timestamp);

  const deviceTitle = isEventTab ? '' : (
    <LogInlineLink to={deviceUrl} text={device?.title} isMobile={isMobile} />
  );

  const shipmentLabel = isEventTab ? '' : (
    <LogInlineLink to={`/shipment/${shipment?.id}`} text={shipment?.label} isMobile={isMobile} />
  );

  const applianceLabel = isEventTab ? '' : (
    <LogInlineLink to={`/warehouse/appliance-overview/${appliance?.id}`} text={appliance?.label} isMobile={isMobile} />
  );
  const applianceGroupSuffix = applianceGroup?.label ? `, group "${applianceGroup.label}"` : '';

  const projectTitle = isEventTab ? '' : (
    <LogInlineLink to={`/project/edit/${project?.id}`} text={project?.title} isMobile={isMobile} />
  );

  try {
    switch (id) {
      case deviceSettingsEventType.EDIT_SETTINGS:
        return (
          <>
            Settings
            {wasEdited}
            edited in
            {deviceTitle}
          </>
        );
      case shipmentEventType.ADD_DEVICE:
        return (
          <>
            Device
            {deviceTitle}
            {wasEdited}
            added to shipment
            {shipmentLabel}
          </>
        );
      case shipmentEventType.REMOVE_DEVICE:
        return (
          <>
            Device
            {deviceTitle}
            {wasEdited}
            removed from shipment
            {shipmentLabel}
          </>
        );
      case warehouseEventType.ADD_DEVICE:
        return (
          <>
            Device
            {deviceTitle}
            {wasEdited}
            added to application
            {applianceLabel}
            {applianceGroupSuffix}
          </>
        );
      case warehouseEventType.REMOVE_DEVICE:
        return (
          <>
            Device
            {deviceTitle}
            {wasEdited}
            removed from application
            {applianceLabel}
            {applianceGroupSuffix}
          </>
        );
      case projectEventType.ADD_DEVICE:
        return (
          <>
            Device
            {deviceTitle}
            {wasEdited}
            added to project
            {projectTitle}
          </>
        );
      case projectEventType.DELETE_DEVICE:
        return (
          <>
            Device
            {deviceTitle}
            {wasEdited}
            removed from project
            {projectTitle}
          </>
        );
      default:
        return 'Not recognized event';
    }
  } catch (e) {
    return 'Not recognized event';
  }
};

export default EventDescription;
